import { ScrollArea } from '@pesto/ui/components/ScrollArea';
import { Tabs, TabsList, TabsTrigger } from '@pesto/ui/components/Tabs';
import { format } from 'date-fns';

import type { StatementListItem } from '../types/Statements.types';

const formatCompactBillingPeriod = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();

  if (sameMonth) {
    return `${format(start, 'd')}-${format(end, "d MMM ''yy")}`;
  }

  return `${format(start, 'd MMM')} - ${format(end, "d MMM ''yy")}`;
};

export const sortByBillingPeriod = (statements: StatementListItem[]) =>
  [...statements].sort((a, b) => new Date(a.billingPeriodStart).getTime() - new Date(b.billingPeriodStart).getTime());

interface StatementPeriodNavProps {
  statements: StatementListItem[];
  activeStatementId: string;
  onSelect: (statementId: string) => void;
}

export const StatementPeriodNav = ({ statements, activeStatementId, onSelect }: StatementPeriodNavProps) => {
  if (statements.length === 0) return null;

  return (
    <Tabs value={activeStatementId} onValueChange={onSelect}>
      <ScrollArea orientation="horizontal">
        <TabsList>
          {statements.map((statement) => (
            <TabsTrigger key={statement.id} value={statement.id}>
              {formatCompactBillingPeriod(statement.billingPeriodStart, statement.billingPeriodEnd)}
            </TabsTrigger>
          ))}
        </TabsList>
      </ScrollArea>
    </Tabs>
  );
};
